import $ from 'jquery';
import StateManager from '../scuba/StateManager';

const Cart = {
  total: 0,
  quantity: 0,
  refresh: function () {
    $("body").addClass('is-cart-loading');
    $.get(window.wp.ajax, {action : "cart"}, json => {
      Cart.reloadItems(json);
    });
  },
  reloadItems: function (json) {
    $( document.body ).trigger( 'update_checkout' );
    $(".js-cart").html(json.html);
    Cart.total = json.total;
    Cart.quantity = json.quantity;

    Cart.animateTextChange($(".js-cart__total"), Cart.total);
    Cart.animateTextChange($(".js-cart__count"), Cart.quantity);

    if(Cart.quantity === 0){
      $("body").addClass("is-cart-empty");
    } else {
      $("body").removeClass("is-cart-empty");
    }
    $("body").removeClass('is-cart-loading');
  },
  add: function(product, quantity, cb) {
    Cart.cartAddOrUpdate("cart__add", product, quantity, cb);
  },
  remove: function(product) {
    Cart.cartAddOrUpdate("cart__remove", product, 0);
  },
  updateQuantity: function(product, quantity) {
    Cart.cartAddOrUpdate("cart__update__quantity", product, quantity);
  },
  cartAddOrUpdate: function(action, product, quantity, cb) {
    $("body").addClass('is-cart-loading');
    $.post(window.wp.ajax, {
        action : action,
        product_id : product,
        product_quantity : quantity,
      }, json => {
      Cart.reloadItems(json);
      if(cb){
        cb();
      }
    });
  },
  animateTextChange: function($el, text) {
    $el.html(text)
      .addClass("is-animated").one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass("is-animated");
      });
  },
};

$(window).on(StateManager.CONTENT_READY, function(event, node) {
  $(node).find(".js-cart__total").text(Cart.total);
  $(node).find(".js-cart__count").text(Cart.quantity);
});

$(document).ready(function() {
  $(document).on("change", ".js-cart__quantity__input", e => {
    var $input = $(e.currentTarget);
    var $parent = $input.closest(".js-cart__quantity");
    Cart.updateQuantity($parent.data("product-id"), $input.val());
  });
  $(document).on("click", ".js-cart__add:not(.is-loading)", e => {
    var $button = $(e.currentTarget);
    $button.addClass('is-loading');
    $button.closest(".c-product").find(".c-product__confirmation").removeClass("is-visible");
    Cart.add($button.data("product-id"), $button.closest(".c-product__form").find('.js-quantity__input').first().val(), function(){
      console.log($button);
      $button.closest(".c-product").find(".c-product__confirmation").addClass("is-visible");
      $button.removeClass('is-loading');
    })
    e.preventDefault();
  });
  $(document).on("click", ".js-cart__remove", e => {
    Cart.remove($(e.currentTarget).data("product-id"))
    e.preventDefault();
  });

  $(document).on('click', '.js-cart__toggle', e => {
    $("body").toggleClass('has-cart-open');
    if($(e.currentTarget).attr("href") === "#"){
      e.preventDefault();
    }
  });

  $(document).on('click', '.js-cart__open', e => {
    $("body").addClass('has-cart-open');
    if($(e.currentTarget).attr("href") === "#"){
      e.preventDefault();
    }
  });

  $(document).on("click", ".has-cart-open .js-scuba__main", e => {
    $("body").removeClass('has-cart-open');
    e.preventDefault();
  });
  $(document.body).on('layout:change', function(event, layout) {
      if (!layout) return;
      if(layout === 'MobileLayout'){
        $(".c-cart").insertAfter('.js-scuba__head');
      } else {
        $(".c-cart").insertAfter('.js-scuba__root');
      }
  });
});

export default Cart;



// WEBPACK FOOTER //
// ./scripts/components/Cart.js